export default __webpack_public_path__ + "static/media/ep5collage2.4c047dd2.jpg";